import React, { useState } from 'react';
import UserList from './UserList';
import UserDetail from './UserDetail';
import { useLanguage } from '../../contexts/LanguageContext';
import './UserManagement.scss';

const UserManagement = () => {
    const [selectedUser, setSelectedUser] = useState(null);
    const [activeView, setActiveView] = useState('list'); // 'list' | 'detail'
    const { t } = useLanguage();

    const handleUserSelect = (user) => {
        setSelectedUser(user);
        setActiveView('detail');
    };

    const handleBackToList = () => {
        setActiveView('list');
        setSelectedUser(null);
    };

    return (
        <div className="user-management-container">
            {activeView === 'list' && (
                <UserList onUserSelect={handleUserSelect} />
            )}

            {activeView === 'detail' && selectedUser && (
                <div>
                    <button onClick={handleBackToList} className="back-button">
                        ← {t('backToList')}
                    </button>
                    <UserDetail user={selectedUser} />
                </div>
            )}
        </div>
    );
};

export default UserManagement;